import apiUtils from '../apiService/utils';



export interface Ficha {
  fichaInfo:   FichaInfo;
  unidadInfo:  UnidadInfo;
  clienteInfo: ClienteInfo;
}

export interface ClienteInfo {
  ApellidosCuenta:          string;
  NombresRazonSocialCuenta: string;
  IdentificadorFiscal:      string;
  TipoCuenta:               string;
  Mail:                     string;
  Direccion:                string;
  Calle:                    string;
  Numero:                   string;
  DeptoOfCasa:              string;
  ComunaDesc:               string;
  DescGiro:                 string;
}

export interface FichaInfo {
  cliente: string;
}

export interface UnidadInfo {
  descSector:      string;
  descriComercial: string;
  vin:             string;
  patente:         string;
  descCanal:       string;
}

const getSalesDetails = async (
  nroFicha: string,
): Promise<Ficha> => {
  try {
    console.log('fetching sales details...');
    const result = await apiUtils.axiosInstance.post('/getSalesDetails', {
      nroFicha,
    });
    return result.data as Ficha;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching sales details:', error);
    throw error;
  }
};

export default getSalesDetails;
